module.exports = __webpack_public_path__ + "static/assets/cdf71f36614586632e5d600e2a15405d.gif";